Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    bp = _STYLES$useStyles.bp,
    spacing = _STYLES$useStyles.spacing,
    grid = _STYLES$useStyles.grid,
    fontBold = _STYLES$useStyles.fontBold,
    colors = _STYLES$useStyles.colors,
    fontSize = _STYLES$useStyles.fontSize,
    lineHeight = _STYLES$useStyles.lineHeight;
  var modalContentHeading = {
    textAlign: 'center',
    alignSelf: 'center',
    marginBottom: spacing.xl
  };
  var modalCardStyle = {
    maxWidth: grid.maxBoxWidth,
    paddingLeft: spacing.xl,
    paddingRight: spacing.xl,
    paddingBottom: spacing.xl
  };
  if (bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal])) {
    modalCardStyle.paddingLeft = spacing.normal;
    modalCardStyle.paddingRight = spacing.normal;
    modalCardStyle.paddingBottom = spacing.normal;
  }
  var title = {
    marginBottom: spacing.l,
    alignSelf: 'center',
    textAlign: 'center'
  };
  var text = Object.assign({}, fontBold, {
    marginBottom: spacing.l,
    color: colors.brand,
    fontSize: fontSize.l,
    lineHeight: lineHeight.l,
    textAlign: 'center'
  });
  var highlight = {
    color: colors.alternative
  };
  var share = {
    marginBottom: spacing.xl
  };
  var styles = _reactNative.StyleSheet.create({
    modalContentHeading: modalContentHeading,
    modalCardStyle: modalCardStyle,
    title: title,
    text: text,
    highlight: highlight,
    share: share
  });
  return {
    styles: styles
  };
};